module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messageModal"
  }, [(_vm.messageData.title) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.messageData.title) + " ")]) : _vm._e(), _vm._v(" "), (_vm.messageData.message) ? _c('div', {
    staticClass: "message raleway",
    domProps: {
      "innerHTML": _vm._s(_vm.messageData.message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.messageData.confirm) ? _c('div', {
    staticClass: "confirmButtons text-center"
  }, [(_vm.messageData.confirmTxt) ? _c('div', {
    class: {
      button: true, primaryButton: _vm.messageData.primaryButton == 'confirm'
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" " + _vm._s(_vm.messageData.confirmTxt) + " ")]) : _vm._e(), _vm._v(" "), (_vm.messageData.declineTxt) ? _c('div', {
    class: {
      button: true, primaryButton: _vm.messageData.primaryButton == 'decline'
    },
    on: {
      "click": _vm.decline
    }
  }, [_vm._v(" " + _vm._s(_vm.messageData.declineTxt) + "  ")]) : _vm._e(), _vm._v(" "), (_vm.messageData.abortTxt) ? _c('div', {
    class: {
      button: true, primaryButton: _vm.messageData.primaryButton == 'abort'
    },
    on: {
      "click": _vm.abort
    }
  }, [_vm._v(" " + _vm._s(_vm.messageData.abortTxt) + "  ")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b95399e2!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Modals/Content/Message.vue
// module id = 170
// module chunks = 0